// body 滚动锁 (2026-09-22): 弹层打开时锁住页面滚动, 全部关闭后恢复.
//
// 不要各自 `prev = body.style.overflow` / 关闭时写回 prev —— 弹层会叠加 (Modal 上再弹
// DialogHost 提示, 或 Modal 的 effect 因 onClose 身份变化而重跑), 后来者会把别人设的
// 'hidden' 当成"原始值"记下来, 最后一个关闭时写回 'hidden', 页面就永久滚不动了.
// 这里用引用计数: 第一把锁记录真实原值, 最后一把锁释放时才恢复.

let locks = 0;
let original = '';

/** 加一把锁; 返回释放函数 (幂等, 直接给 useEffect 当 cleanup 用). */
export function lockBodyScroll(): () => void {
    if (locks === 0) {
        original = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
    locks += 1;
    let released = false;
    return () => {
        if (released) return;
        released = true;
        locks -= 1;
        if (locks <= 0) {
            locks = 0;
            document.body.style.overflow = original;
        }
    };
}
